// store/module/deviceInfo.js
import { defineStore } from "pinia";
import { ref } from "vue";

const useDeviceInfoStore = defineStore("deviceInfo", () => {
    // 设备信息状态
    const deviceType = ref("");
    const ip = ref("");
    const cfConnectingIp = ref("");
    const country = ref("");
    const cfIpCountry = ref("");
    const cfVisitor = ref("");
    const platform = ref("");
    const browser = ref("");
    const rayid = ref("");
    const device = ref("");
    const useragent = ref("");
    // 是否已加载
    const isLoaded = ref(false);

    // 获取设备信息
    const fetchDeviceInfo = async () => {
        try {
            const response = await fetch("https://backskins.hotgamer.net/device/info");
            const result = await response.json();

            if (result.code === 0 && result.data) {
                const data = result.data;

                deviceType.value = data.device_type || "";
                ip.value = data.ip || "";
                cfConnectingIp.value = data.cf_connecting_ip || "";
                country.value = data.country || "";
                cfIpCountry.value = data.cf_ipcountry || "";
                cfVisitor.value = data.cf_visitor || "";
                platform.value = data.platform || "";
                browser.value = data.browser || "";
                rayid.value = data.ray_id || "";
                device.value = data.device || "";
                useragent.value = data.user_agent || "";
                isLoaded.value = true;

                return result.data;
            }
        } catch (error) {
            console.error("获取设备信息失败:", error);
            throw error;
        }
    };

    // 重置设备信息
    const resetDeviceInfo = () => {
        deviceType.value = "";
        ip.value = "";
        cfConnectingIp.value = "";
        country.value = "";
        cfIpCountry.value = "";
        cfVisitor.value = "";
        platform.value = "";
        browser.value = "";
        isLoaded.value = false;
        rayid.value = "";
        device.value = "";
        useragent.value = "";
    };

    return {
        // 状态
        deviceType,
        ip,
        cfConnectingIp,
        country,
        cfIpCountry,
        cfVisitor,
        platform,
        browser,
        isLoaded,
        rayid,
        device,
        useragent,

        // 方法
        fetchDeviceInfo,
        resetDeviceInfo,
    };
});

// 重要：按照你的项目结构，需要 default 导出一个返回 store 的函数
export default () => useDeviceInfoStore;